<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      size="auto"
      no-padding
      :content-style="contentStyle"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <div v-html="header"></div>
    </template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          :label-width="labelWidth">
        <el-form-item
            :label="label"
            prop="input"
            :class="{'not-margin': notMargin}"
            :rules="[$gjRequired(`请输入${label}`, ['blur', 'change'], required)]">
          <gj-textarea
              v-model="form.input"
              :placeholder="`请输入${label}`"
              rows="5"
              :styles="{width: '300px'}"
          ></gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>

  import {formRuleMixin, modalMixIn} from "../../minxins";

  export default {
    name: "gj-textarea-modal",
    mixins: [modalMixIn, formRuleMixin],
    props: {
      header: {
        required: true
      },
      label: {
        required: true
      },
      labelWidth: {
        required: true
      },
      required: {
        default: true
      },
      contentStyle: {
        default: () => {}
      },
      notMargin: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        form: {
          input: null
        }
      }
    },
    methods: {
      confirm() {
        if (this.$gjFormValidate()) {
          this.$emit('submit', this.form.input);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .not-margin{
    margin-bottom: 0;
  }
</style>
